<script setup>
import { ref, onMounted } from 'vue'
import {
  DxChart,
  DxSeries,
  DxLegend,
  DxTooltip,
  DxCommonSeriesSettings,
  DxLabel,
} from 'devextreme-vue/chart'
import { planningApi } from '@/apis/planning.api'

const data = ref(null)

onMounted(async () => {
  const res = await planningApi.getEquipmentConditionSummaryAsync()
  data.value = res.data
})

const customizeTooltip = ({ seriesName, value, point }) => {
  const wh = point.data?.warehouse ?? ''
  const descriptions = {
    Good: 'Good or Great condition',
    'Needs Cleaning': 'Needs Cleaning',
    'Broken / Needs Repair': 'Broken or Needs Repair — requires immediate attention',
  }
  return { text: `${wh} · ${seriesName}\n${value} item${value !== 1 ? 's' : ''}\n${descriptions[seriesName] ?? ''}` }
}
</script>

<template>
  <div class="fit column" style="padding-left: 8px">
    <div v-if="data === null" class="col flex flex-center">
      <q-spinner size="md" color="primary" />
    </div>
    <dx-chart
      v-else
      :data-source="data"
      class="col"
      :bar-group-padding="0.5"
      :bar-group-width="120"
    >
      <dx-common-series-settings type="bar" argument-field="warehouse">
        <dx-label :visible="true" />
      </dx-common-series-settings>
      <dx-series value-field="green" name="Good" color="#388E3C" />
      <dx-series value-field="yellow" name="Needs Cleaning" color="#F9A825" />
      <dx-series value-field="red" name="Broken / Needs Repair" color="#C62828" />
      <dx-legend :visible="true" horizontal-alignment="center" vertical-alignment="bottom" />
      <dx-tooltip :enabled="true" :customize-tooltip="customizeTooltip" />
    </dx-chart>
  </div>
</template>
